import React from 'react';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';

const ContactInfo = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      justifyContent: 'center',
      gap: { xs: 2, sm: 3 },
      px: { xs: 0, sm: 2 }
    }}>
      <Button
        variant="contained"
        startIcon={<LocationOnIcon />}
        href="https://maps.app.goo.gl/aH8Y2B29HphMwBzz8"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          borderRadius: '12px',
          textTransform: 'none',
          fontWeight: 700,
          fontSize: { xs: 15, sm: 16 },
          px: { xs: 3, sm: 4 },
          py: { xs: 1.5, sm: 1.75 },
          background: 'linear-gradient(135deg, #ed5034 0%, #ff6b4a 100%)',
          color: '#fff',
          border: 'none',
          boxShadow: '0 4px 20px rgba(237, 80, 52, 0.4)',
          transition: 'all 0.3s ease',
          '&:hover': {
            background: 'linear-gradient(135deg, #ff6b4a 0%, #ed5034 100%)',
            transform: 'translateY(-2px)',
            boxShadow: '0 6px 30px rgba(237, 80, 52, 0.6)'
          },
        }}
      >
        {t('contact.viewOnMap', 'Виж в картата')}
      </Button>
      <Button
        variant="outlined"
        startIcon={<PhoneIcon />}
        href="tel:+359878101363"
        sx={{
          borderRadius: '12px',
          textTransform: 'none',
          fontWeight: 700,
          fontSize: { xs: 15, sm: 16 },
          px: { xs: 3, sm: 4 },
          py: { xs: 1.5, sm: 1.75 },
          color: '#fff',
          borderColor: 'rgba(255, 255, 255, 0.3)',
          borderWidth: '2px',
          bgcolor: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(10px)',
          transition: 'all 0.3s ease',
          '&:hover': {
            bgcolor: '#fff',
            color: '#ed5034',
            borderColor: '#fff',
            borderWidth: '2px',
            transform: 'translateY(-2px)',
            boxShadow: '0 6px 30px rgba(255, 255, 255, 0.3)'
          },
        }}
      >
        {t('contact.callNow', 'Обади се сега')}
      </Button>
    </Box>
  );
};

export default ContactInfo;
